import { Stage, CodeSource } from './types';
import { Action, CHANGE_STAGE, DEACTIVATE, Lifecycle } from './actions';
import { SHOW_AUTH_MODAL, AppAction } from '../../actions/app';

interface SecondFactor {
  codeSource: CodeSource;
  sessionId: string;
}

export interface State {
  stage: Stage;
  secondFactor?: SecondFactor;
}

const initState: State = {
  stage: 'loginAndPassword',
};

export default function (state: State = initState, action: Action | Lifecycle | AppAction) {
  switch (action.type) {
    case CHANGE_STAGE:
      return {
        ...state,
        stage: action.payload.stage,
        secondFactor: action.payload.sessionId
          ? {
              sessionId: action.payload.sessionId,
              codeSource: action.payload.codeSource,
            }
          : undefined,
      };

    case DEACTIVATE:
    case SHOW_AUTH_MODAL:
      return initState;

    default:
      return state;
  }
}
